import useSWR from 'swr';

export const useCoupons = () => {
  const { data, error, isLoading, mutate } = useSWR('/coupons/list');

  return {
    data,
    error,
    isLoading,
    mutate,
  };
};

